module.exports = __webpack_public_path__ + "media/svg/ss-97c89cce.svg";